<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerText]="'SIMStation Update'"
	[headerIcon]="{fontSet: 'far', fontIcon: 'fa-history'}"
	[showClosingX]="!isDownloading && !isInstalling"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="autoUpdateContainer">
			<div class="autoUpdateSection">
				<div class="autoUpdateSectionTitle">
					<h2>
						<i class="fad fa-exclamation-triangle"></i>
						{{ T.GLOBAL_TEXT_HEALTHMONITOR_HEADER | translate }}
					</h2>
				</div>
				<div class="autoUpdateSectionValue">
					<div [innerHTML]="T.GLOBAL_TEXT_HEALTHMONITOR_DESCRIPTION_UPDATE_WARNING | translate"></div>
				</div>
			</div>

			<div class="autoUpdateSection">
				<div class="autoUpdateSectionTitle">
					@if (isDownloading) {
						<div>
							<h4>Progress:</h4>
							<p>Download running...</p>
							<mat-progress-bar color="accent" class="pb-2" mode="determinate" [value]="downloadProgress" />
						</div>
					}

					@if (isInstalling) {
						<div>
							<h4>Progress:</h4>
							<p>Installing SIMStation Updates...</p>
							<mat-progress-bar color="accent" class="pb-2" mode="indeterminate" />
						</div>
					}
				</div>
			</div>
			<div class="autoUpdateSection">
				<div class="autoUpdateSectionTitle">
					<button
						class="large mt-3"
						mat-raised-button
						color="accent"
						(click)="updateSimStation()"
						[disabled]="isDownloading || isInstalling"
					>
						<mat-icon fontSet="far" fontIcon="fa-history" inline />
						Update SIMStation
					</button>
				</div>
			</div>
		</div>
	</ng-container>
</sim-basic-material-dialog>
